export default __webpack_public_path__ + "static/media/check.d92ae0c6.svg";